@if (ttm?.type_key === TtmTypes.temporary_road_markings && !viewedEntity?.plain_image_id) {
    <i class="fa-2x fa-solid fa-road"></i>
} @else {
    <img [src]="blob"/>
    <div class="loading" *ngIf="viewedEntity?.imageLoading">
        <i class="fa fa-spinner fa-spin"></i>
    </div>
}

<ng-content></ng-content>
